<template>
  <div v-if="isVisible" class="popup-wrap fun-selection-gamesCurrency active">
    <div class="popup-box popup-currencySetting">
      <a class="popup-close" @click="closeModal" />
      <div class="form-popup popup-padding">
        <div class="row-frame dep-form-frame colu-12 currency-setting">
          <h4 class="register-title font-w-b text-align-L">
            通貨設定
          </h4>

          <div class="">
            <h4 class="fs-6 fw-700 pb-2 bottomLine">
              現在の表示通貨
            </h4>
            <div class="currency-SelectedFrame">
              <div class="cur-selected">
                <img :src="getCurrencyImagePath(getCurrentCurrencyDisplay())" alt="JPY">
                <b class="">{{ getCurrentCurrencyDisplay() }}</b>
              </div>
            </div>
          </div>

          <div class="">
            <h4 class="fs-6 fw-700 pb-2 bottomLine">
              表示する通貨を選択
            </h4>

            <div class="currency-SelectOptionFrame">
              <div
                v-for="currency in availableCurrencies"
                :key="currency"
                :class="{ active: selectedCurrency === currency }"
                class="cur-option"
                @click="selectedCurrency = currency"
              >
                <img :src="getCurrencyImagePath(currency)" alt="currency">
                <b class="">{{ currency }}</b>
              </div>
            </div>
          </div>

          <div class="d-flex justify-content-center">
            <button class="btn-primary-gold btn-w-100" type="submit" @click="launchGameWithCurrency">
              <span>ゲームを開始する</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { continueGameLaunchWithCurrency } from '@/utils/games'

export default {
  name: 'CurrencySelectionModal',
  props: {
    isVisible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      availableCurrencies: ['JPY', 'USD'],
      selectedCurrency: 'JPY'
    }
  },
  computed: {
    pendingGameData() {
      return this.$store.state.app.pendingGameData
    }
  },
  watch: {
    'isVisible'(newVal) {
      if (newVal) {
        this.initCurrencySelection()
      }
    },
    '$store.state.app.currentGame': {
      handler(newGame) {
        if (newGame && Object.keys(newGame).length > 0) {
          this.initCurrencySelection()
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    closeModal() {
      this.$emit('close')
    },
    initCurrencySelection() {
      let availableCurrencies = ['JPY']

      // Check if wallet type is 'main' - if so, only allow JPY
      if (this.$store.state.app.selectedWallet && this.$store.state.app.selectedWallet.wallet_type === 'main') {
        availableCurrencies = ['JPY']
      } else {
        // Get available currencies from the game
        if (this.$store.state.app.currentGame && this.$store.state.app.currentGame.currency_in_game) {
          const cur = this.$store.state.app.currentGame.currency_in_game
          availableCurrencies = Array.isArray(cur)
            ? cur
            : String(cur).split(',').map(c => c.trim()).filter(Boolean)
        }
      }

      this.availableCurrencies = availableCurrencies

      // Get previously selected currency from localStorage
      const lastSelectedCurrency = localStorage.getItem('lastSelectedGameCurrency')

      // If user has previously selected a currency and it's available for this game
      if (lastSelectedCurrency && availableCurrencies.includes(lastSelectedCurrency)) {
        this.selectedCurrency = lastSelectedCurrency
      } else {
        // Default to JPY if available, otherwise use the first available currency
        this.selectedCurrency = availableCurrencies.includes('JPY')
          ? 'JPY'
          : (availableCurrencies[0] || '')
      }
    },
    launchGameWithCurrency() {
      if (!this.selectedCurrency) return

      // Save the new selection to localStorage
      localStorage.setItem('lastSelectedGameCurrency', this.selectedCurrency)

      // Close this modal
      this.closeModal()

      // Launch the game with the selected currency
      continueGameLaunchWithCurrency(this.selectedCurrency)
    },
    getCurrentCurrencyDisplay() {
      // Return the currently selected currency or the default currency from local storage
      if (this.selectedCurrency) {
        return this.selectedCurrency
      }
      const lastSelectedCurrency = localStorage.getItem('lastSelectedGameCurrency')
      if (lastSelectedCurrency && this.availableCurrencies.includes(lastSelectedCurrency)) {
        return lastSelectedCurrency
      }
      return this.availableCurrencies.includes('JPY') ? 'JPY' : this.availableCurrencies[0] || ''
    },
    getCurrencyImagePath(currency) {
      // Define supported crypto currencies
      const supportedCryptos = [
        'JPY', 'USDT', 'LTC', 'XRP', 'BTC', 'ETH',
        'DOGE', 'BCH', 'TRX', 'BNB', 'USDC', 'SHIB', 'TETH', 'ADA'
      ].map(c => c.toLowerCase())

      // Make sure currency is a string and convert to lowercase
      const currencyLower = String(currency).toLowerCase()

      // JPY icon logic: if currency is JPY, show JPY icon
      if (currencyLower === 'jpy') {
        return require(`@/assets/${this.$store.getters.currentTheme}/images/icon_jpy.svg`)
      }

      // Check if the currency is supported
      if (supportedCryptos.includes(currencyLower)) {
        return require(`@/assets/${this.$store.getters.currentTheme}/images/crypto-${currencyLower}.svg`)
      } else {
        // Return default image for unsupported cryptocurrencies
        return require(`@/assets/${this.$store.getters.currentTheme}/images/default-crypto.svg`)
      }
    }
  }
}
</script>

<style scoped>
.currency-SelectOptionFrame {
	display: flex;
	flex-direction: column;
	gap: 10px;
	margin-bottom: 20px;
}

.cur-option {
	display: flex;
	align-items: center;
	gap: 10px;
	padding: 10px;
	border-radius: 5px;
	cursor: pointer;
	transition: background-color 0.3s;
}

.cur-option:hover, .cur-option.active {
	background-color: rgba(0, 0, 0, 0.05);
}

.cur-option img {
	width: 20px;
	height: 20px;
}
</style>
